module.exports = __webpack_public_path__ + "static/media/q.ba0bcd78.svg";